// magnifier.js
export function magnifierSetup() {
    return {
        showMagnifier: false,
        currentImage: '',
        bgSize: 600, // Zoom level
        bgPos: '0% 0%',
        cursorX: 0,
        cursorY: 0,
        widthImage: 200,
        heightImage: 200,
        pressTimer: null,
        rafId: null,
        lastEvent: null,

        updatePosition() {
            const event = this.lastEvent;
            if (!event) return;
            const isMobile = window.innerWidth < 768;
            const imgRect = event.target.getBoundingClientRect();
            const x = event.clientX - imgRect.left;
            const y = event.clientY - imgRect.top;
            this.bgPos = `${(x / imgRect.width) * 100}% ${(y / imgRect.height) * 100}%`;
            const offsetX = isMobile ? -40 : 20;
            const offsetY = isMobile ? -160 : -220;
            this.cursorX = event.clientX + offsetX - imgRect.left;
            this.cursorY = event.clientY + offsetY - imgRect.top;
            this.rafId = null;
        },

        handleMouseMove(event, imageUrl) {
            const isMobile = window.innerWidth < 768;
            if (!this.currentImage) {
                this.currentImage = imageUrl;
            }
            if (isMobile) {
                this.widthImage = 120;
                this.heightImage = 120;
                this.bgSize = 800;
            }
            if (this.showMagnifier) {
                this.lastEvent = event;
                if (!this.rafId) {
                    this.rafId = requestAnimationFrame(() => this.updatePosition());
                }
            }
        },

        handleTouchStart(event, imageUrl) {
            this.pressTimer = setTimeout(() => {
                this.showMagnifier = true;
                this.currentImage = imageUrl;
            }, 300);
        },

        handleTouchMove(event, imageUrl) {
            if (this.pressTimer) {
                clearTimeout(this.pressTimer);
                this.pressTimer = null;
            }
            if (this.showMagnifier && event.touches.length > 0) {
                this.handleMouseMove(event.touches[0], imageUrl);
            }
        },

        handleTouchEnd(event) {
            if (this.pressTimer) {
                clearTimeout(this.pressTimer);
                this.pressTimer = null;
            }
            this.hideMagnifier();
        },

        hideMagnifier() {
            this.showMagnifier = false;
        },
    }
}
